import { render, staticRenderFns } from "./IconWideView.vue?vue&type=template&id=50f1dfe6"
import script from "./IconWideView.vue?vue&type=script&lang=js"
export * from "./IconWideView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports